export function getTrainingMinutes(trainingHours: string): number {
  if (trainingHours === null || trainingHours === undefined) {
    return null;
  }
  const [hours, minutes] = trainingHours.split(':').map(Number);
  const result = hours * 60 + minutes;
  return Number.isNaN(result) ? -Infinity : result;
}
